import { empresaDataInterface } from "../../pages/Empresa/empresa";

export const safeData: empresaDataInterface = {
    "color": "rgba(193, 27, 59,1)",
    "link": "/safevanguard",
    "icon":"https://media.grupoinveste.pt/emp/safevanguard/icon.png",
    "logo_white":"https://media.grupoinveste.pt/emp/safevanguard/horizontal_white.png",
    "logo_vertical":"https://media.grupoinveste.pt/emp/safevanguard/vertical_white.png",
    "header": {
        "website": "https://safevanguard.com/",
        "banner": "https://media.grupoinveste.pt/emp/safevanguard/banner.jpg",
        "tags": [
            "safe.tags.0", "safe.tags.1", "safe.tags.2",
        ],
        "name": "safe.name",
        "slogan": "safe.slogan"
    },
    "section1": {
        "img": "https://media.grupoinveste.pt/emp/safevanguard/horizontal_black.png",
        "title_1": "safe.section1.title1",
        "text_1": "safe.section1.text1",
        "text_2": "safe.section1.text2",
        "title_2": "safe.section1.title2",
        "text_3": "safe.section1.text3",
        "text_4": "safe.section1.text4",
    },
    "section2": [
        {
            "title": "safe.section2.0.title",
            "text": [
                "safe.section2.0.text.0", "safe.section2.0.text.1", "safe.section2.0.text.2"
            ]
        },
        {
            "title": "safe.section2.1.title",
            "text": [
                "safe.section2.1.text.0"
            ]
        },
        {
            "title": "safe.section2.2.title",
            "text": [
                "safe.section2.2.text.0", "safe.section2.2.text.1", "safe.section2.2.text.2"
            ]
        }
    ],
    "section3": {
        "title": "safe.section3.title",
        "text": "safe.section3.text",
        "link": "https://www.safevanguard.com/"
    }
}